/**
 * File Name          : communication-types.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.0.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_BACKGROUNDTECH_LICENSE.txt', which is part of this source code package.
 */

import { ResponsePacket } from './packets/response-packet.model';
import { AppResponsePacket } from './packets/app-response-packet.model';
import { Packet } from './packets/packet.model';
import { CommandPacket } from './packets/command-packet.model';
import { AppCommandPacket } from './packets/app-command-packet.model';

export type PacketResponsePromise = Promise<[ResponsePacket, Packet|CommandPacket, {elapsedTime: number}]>;
export type AppResponsePacketPromise = Promise<[AppResponsePacket, Packet|AppCommandPacket, {elapsedTime: number}]>;

export enum CommunicationType {
  RX_PACKET,
  TX_PACKET,
  DISCARD_BYTES
}
